import BannerApi from '@/api/common/banner';
import LogApi from '@/api/common/log';
import {
  BANNER_REQUEST_TYPE,
  BANNER_RESPONSE_TYPE,
} from '@/constants/main/banner';
import useMainStore from '@/stores/main';
import {useState, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

const formattedMainBanner = (banner) => {
  if (!banner || !banner.length === 0) {
    return [];
  }

  return banner.map((item) => {
    const {advertiser, adText, imageUrl, ...rest} = item;
    return {
      isBanner: true,
      thumbnailSrc: imageUrl, //썸네일
      title: adText, //광고제목
      userNickname: advertiser, //광고주
      ...rest,
    };
  });
};

export const useBanner = ({type, category, posterCategory}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const {
    banner,
    checkAd,
    setBanner,
    setIsShowMainBanner,
    setIsCloseMainBanner,
  } = useMainStore();
  const location = useLocation();

  const handleClickClose = (closeUrl) => {
    //배너 닫힘 트래킹
    if (isOpen) {
      if (checkAd.AdParameter.hasOwnProperty('sendTracking')) {
        checkAd.AdParameter.sendTracking(closeUrl);
      }
    }
    setIsOpen(!isOpen);
  };

  // 기존 코드에서 이 부분만 수정
  const hasCalledErrorTracking = useRef(false);
  const handelErrorImage = (e, errorUrl, alterImageUrl = '') => {
    // 트래킹이 이미 한 번 된 경우, 더 이상 동작하지 않도록 예외 처리
    if (hasCalledErrorTracking.current) {
      return;
    }
    if (checkAd.AdParameter.hasOwnProperty('sendTracking')) {
      if (alterImageUrl) {
        e.target.src = alterImageUrl;
      }
      checkAd.AdParameter.sendTracking(errorUrl);
      hasCalledErrorTracking.current = true;
    }
  };

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  //배너 클릭 트래킹
  const handleClickBanner = (clickUrl) => {
    if (checkAd.AdParameter.hasOwnProperty('sendTracking')) {
      checkAd.AdParameter.sendTracking(clickUrl);
    }
  };

  //광고 배너 호출
  useEffect(() => {
    if (
      (type === 'main' &&
        !banner.main.exist &&
        location.key !== banner.main.key &&
        checkAd.banners?.bAdPcMainBanner) ||
      (type === 'sub' &&
        !banner.sub.exist &&
        location.key !== banner.sub.key &&
        checkAd.banners?.bAdPcCategoryBanner)
    ) {
      getBanner();
    }
  }, [checkAd]);

  useEffect(() => {
    if (
      (category && category !== banner.sub.category) ||
      (posterCategory && posterCategory.active === 'poster')
    ) {
      setIsOpen(false);
      setHovered(false);
      setBanner({
        ...banner,
        sub: {
          key: '',
          type: '',
          exist: false,
          category: '',
          creatives: [],
        },
      });
    }
  }, [category, posterCategory.categoryNo]);

  useEffect(() => {
    if (
      type === 'sub' &&
      banner.sub.exist &&
      banner.sub.category === category &&
      checkAd.AdParameter.hasOwnProperty('sendTracking')
    ) {
      checkAd.AdParameter.sendTracking(banner.sub.creatives[0]?.impressionUrls);
      if (
        banner.sub.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO ||
        banner.sub.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE ||
        banner.sub.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO_SUB ||
        banner.sub.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE_SUB
      ) {
        checkAd.AdParameter.sendTracking(banner.sub.creatives[0]?.viewableUrls);
      }
    }
  }, [banner[type].exist]);

  const getBanner = async () => {
    try {
      if (checkAd.AdParameter.hasOwnProperty('getAdParameters')) {
        const params = checkAd.AdParameter.getAdParameters(
          type === 'main'
            ? BANNER_REQUEST_TYPE.MAIN_BANNER
            : BANNER_REQUEST_TYPE.SUB_BANNER,
          {category: category},
        );
        const response = await BannerApi.getBanner(params);
        if (response) {
          hasCalledErrorTracking.current = false;
          if (type === 'main') {
            //정의된 type으로 내려오는 광고만 노출
            if (
              response.exist &&
              (response.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE ||
                response.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO)
            ) {
              setBanner({
                ...banner,
                main: {
                  key: location.key,
                  type: response.type,
                  exist: response.exist,
                  creatives: [...formattedMainBanner(response.creatives)],
                },
              });
              const adInfo = {
                func: 'getBanner',
                ad_type: response.type,
                location: 'main',
              };
              LogApi.sendTestAdInfoLog(adInfo);
            } else {
              //광고없음 상태
              setIsShowMainBanner(false);
              setIsCloseMainBanner(true);
            }
          } else if (type === 'sub') {
            if (
              response.exist &&
              (response.type === BANNER_RESPONSE_TYPE.PC_728_90_BANNER ||
                response.type ===
                  BANNER_RESPONSE_TYPE.PC_SUB_BANNER_EXPANDED_IMAGE ||
                response.type ===
                  BANNER_RESPONSE_TYPE.PC_SUB_BANNER_EXPANDED_VIDEO ||
                response.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO ||
                response.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE ||
                response.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO_SUB ||
                response.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE_SUB)
            ) {
              setBanner({
                ...banner,
                sub: {
                  key: location.key,
                  type: response.type,
                  exist: response.exist,
                  category: category,
                  creatives: [...formattedMainBanner(response.creatives)],
                },
              });
            }
          }
        }
      }
    } catch (error) {
      if (type === 'main') {
        setIsShowMainBanner(false);
        setBanner({
          ...banner,
          main: {
            key: '',
            type: '',
            exist: false,
            creatives: [],
          },
        });
      } else if (type === 'sub') {
        setHovered(false);
        setIsOpen(false);
        setBanner({
          ...banner,
          sub: {
            key: '',
            type: '',
            exist: false,
            category: '',
            creatives: [],
          },
        });
      }
    }
  };

  useEffect(() => {
    let timer;
    if (hovered && !isOpen) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        setIsOpen(true);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [hovered, isOpen]);

  const state = {isOpen, banner};
  const handler = {
    handleClickClose,
    handleClickBanner,
    handelErrorImage,
    handleMouseEnter,
    handleMouseLeave,
  };
  return {...state, ...handler};
};
